import { ReduxSagaRequest } from "@hlibs/index";
import * as Requests from "./requests";

class Files extends ReduxSagaRequest {
  static create = (name, funcAsync = null, funcResult = null) =>
    new Files(name, funcAsync, funcResult);
  get file() {
    return super.getState("file");
  }
  // callback : (data, response) => {}
  uploadAdBanner(file, callback = null) {
    super.request({ type: "UploadAdBanner", params: { file }, callback });
  }
  // list(callback = null) {
  //   super.request({ type: "List", callback });
  // }
  // info(ad_id, callback = null) {
  //   super.request({ type: "Info", params: { ad_id }, callback });
  // }
  // cleanLoginResponse() {
  //   super.set(null, "excel");
  // }
}

const reduxModule = Files.create("Files", async (payload) => {
  switch (payload.type) {
    case "UploadAdBanner":
      return await Requests.UploadAdBanner(
        payload.params,
        payload.callback,
        reduxModule
      );
    // case "List":
    //   return await Requests.List(payload.callback, reduxModule);
    // case "Info":
    //   return await Requests.Info(payload.params, payload.callback, reduxModule);

    default:
      return null;
  }
});

export default reduxModule;
